<template>
  <b-container class="mt-3">
    <b-row>
      <login-regist xl="6" lg="6" cols="12" class="mt-2" @submit="onRegisted" :key="componentKey"></login-regist>
      <b-col xl="6" lg="6" cols="12" class="mt-2 pl-5">
        <b-form @submit.prevent="onClickToLogin">
          <h4 class="py-2">
            <span class="mark-bottom">我有會員帳號</span>
          </h4>
          <p>請填寫您的帳號與密碼</p>
          <b-form-group id="username-fieldset" label-for="username" :invalid-feedback="UsernameInvalidFeedback" :state="UsernameState">
            <template slot="label">
              <span class="text-danger">*</span>帳號
            </template>
            <b-form-input id="username" v-model="username" :state="UsernameState" trim required @change="markChange('username')" @keydown.enter="onClickToLogin"></b-form-input>
          </b-form-group>
          <b-form-group id="password-fieldset" label-for="password" :state="PasswordState">
            <template slot="label">
              <span class="text-danger">*</span>密碼
            </template>
            <b-form-input id="password" type="password" v-model="password" :state="PasswordState" trim required @change="markChange('password')" @keydown.enter="onClickToLogin" autocomplete="false"></b-form-input>
          </b-form-group>
          <b-button :disabled="!allValid || busy" type="submit" block class="btn-pur-dark">登入</b-button>
        </b-form>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import LoginRegist from './LoginRegist'
export default {
  components: {
    LoginRegist
  },
  data () {
    return {
      username: '',
      password: '',
      changed: {},
      busy: false,
      componentKey: Date.now()
    }
  },
  computed: {
    UsernameInvalidFeedback () {
      if (this.username.length >= 6) {
        return ''
      } else if (this.username.length > 0) {
        return '帳號至少需要6位'
      } else {
        return '請填入帳號'
      }
    },
    UsernameState () {
      if (!this.changed.username) return undefined
      return this.username.length >= 6
    },
    PasswordState () {
      if (!this.changed.password) return undefined
      return this.password.length !== 0
    },
    allValid () {
      return this.UsernameState && this.PasswordState
    }
  },
  methods: {
    async onClickToLogin () {
      if (this.busy) return
      this.busy = true
      try {
        await this.$api.loginUser({
          username: this.username,
          password: this.password
        })
        this.$bvToast.toast('稍後將自動跳轉。', {
          title: '登入成功',
          variant: 'success'
        })
        this.$bus.$emit('update:cart')
        this.back()
      } catch (e) {
        this.$bvToast.toast('您輸入的資訊不正確，請嘗試多次或聯絡管理員。', {
          title: '登入失敗',
          variant: 'danger'
        })
        this.busy = false
      }
    },
    async onRegisted (err, data) {
      if (err) {
        this.$bvToast.toast('您輸入的資訊不正確或已重複，請嘗試多次或聯絡管理員。', {
          title: '註冊失敗',
          variant: 'danger'
        })
      } else {
        await this.$api.loginUser(data)
        this.$bvToast.toast('稍後將進行跳轉。', {
          title: '註冊成功',
          variant: 'success'
        })
        this.back()
      }
      this.componentKey = Date.now()
    },
    back () {
      const from = this.$route.query.nextUrl || '/'
      console.log(this.$route)
      setTimeout(() => this.$router.push(from), 3000)
    },
    markChange (name) {
      this.$set(this.changed, name, true)
    }
  }
}
</script>
